/* istanbul ignore file */
import { fork } from 'redux-saga/effects'
import watchUser from './user'
import watchAnalytics from './analytics'
import watchNavigation from './navigation'
import watchRates from './rates'
import watchRentalCarContract, { watchContractRentalCar, watchReceiveRentalCarContract } from './rentalCarContract'
import watchBuildBooking, { watchUpdateBooking } from './booking'

export default function * root () {
    yield [
        fork(watchUser),
        fork(watchNavigation),
        fork(watchAnalytics),
        fork(watchRates),
        fork(watchReceiveRentalCarContract),
        fork(watchRentalCarContract),
        fork(watchBuildBooking),
        fork(watchUpdateBooking),
        fork(watchContractRentalCar),
    ]
}
